import { useEffect } from 'react';

// user for api calling after some time
const useDebouncedEffect = (effect, deps, delay) => {
  useEffect(() => {
    const handler = setTimeout(() => {
      effect();
    }, delay);

    // Cleanup the timeout if effect or deps change
    return () => clearTimeout(handler);
  }, [...deps, delay]);
};

export default useDebouncedEffect;
